import morningHorizon from "../themes/morning-horizon/index.js";
import eveningHorizon from "../themes/evening-horizon/index.js";

import deepMerge from "./utils/deep-merge.js";
import addLegacyAliases from "./utils/add-legacy-aliases.js";
import flatObjectConverter from "./utils/flat-object.js";

const themeConfigs = [morningHorizon, eveningHorizon];

const themes = [];

themeConfigs.forEach((theme) => {
  const basePalette = theme.extend?.palette || {};
  const palette = deepMerge(basePalette, theme?.palette || {});

  const baseAliases = theme.extend?.aliases(palette) || {};
  const aliases = deepMerge(baseAliases, theme.aliases?.(palette) || {});
  const aliasesWithLegacy = addLegacyAliases(aliases);

  const baseTokens = theme.extend?.tokens(palette, aliases) || {};
  const tokens = deepMerge(baseTokens, theme.tokens?.(palette, aliases) || {});

  themes.push({
    name: theme.name,
    id: theme.id,
    sapId: theme.sapId,
    thumbnail: theme.thumbnail,
    properties: {
      status: theme.status,
    },
    config: {
      palette,
      aliases: aliasesWithLegacy,
      tokens,
    },
    variables: flatObjectConverter({
      ...palette,
      ...aliasesWithLegacy,
      ...tokens,
    }),
  });
});

export default themes;
